/**
 * 行先番号を決まった幅に収める。
 *
 * 行先番号は長さがばらつく（`23N` `230` `22-1` `BRT` `快速1` `無番`）。
 * そのままだと枠の幅が台ごとに変わって、線の上に並んだとき列が揃わない。
 *
 * **箱の幅は 1.5em に固定し、はみ出すぶんだけ横に潰す。**収まるものは潰さず
 * 中央に置く。縦は変えないので高さは揃ったまま。
 *
 * ## 半角は 0.5em ではない
 *
 * 最初は半角を 0.5em と数えていたが、**実際の数字の字幅は 0.55〜0.6em** ある。
 * そのため `23-2`（半角 4 文字）が 0.75 倍でも 1.5em に収まらず、見切れた。
 * `23N` も本当は 1.5em を少し超えていた。
 *
 * 見積もりを実寸側に寄せて 0.6em で数える。**数字の幅を揃える**（CSS の
 * tabular-nums）ことで、この見積もりが当たるようにしてある。
 */

/** 半角 1 文字の幅（em）。**0.5 ではない**（上記） */
export const HALF_EM = 0.6;

/**
 * 箱の幅（em）。**半角 3 文字がそのまま入る幅を基準にする。**
 *
 * 行先番号でいちばん多い形が半角 3 文字（`23N` `230` `22N` `BRT`）なので、
 * そこを潰さない。潰すのは半角 4 文字以上と全角 2 文字以上だけ。
 *
 * **CSS の .lm-bus__route の width と揃えること。**
 */
export const FIT_EM = HALF_EM * 3;

/**
 * 文字列の見た目の幅（em）。
 *
 * 半角の範囲は ASCII の印字可能文字と半角カタカナ。それ以外（漢字・かな・
 * 全角英数）は 1em と数える。
 */
export function visualWidth(text) {
  return Array.from(String(text ?? "")).reduce(
    (w, ch) => w + (/[ -~｡-ﾟ]/.test(ch) ? HALF_EM : 1),
    0
  );
}

/**
 * 箱に収めるための横の倍率。**収まるなら 1（潰さない）。**
 *
 * @param {string} text 行先番号
 * @param {number} em   箱の幅（em）
 * @returns {number} 1 以下の倍率
 */
export function routeScale(text, em = FIT_EM) {
  const w = visualWidth(text);

  return w > em ? em / w : 1;
}
